import { combineReducers } from 'redux';

import AppReducer from "../state/app/appReducer";
import AuthReducer from "../state/auth/authReducer";
import OrderReducer from "../state/order/reducer";
import AssociateReducer from "../state/associate/reducer";
import EntregadorReducer from "../state/entregador/reducer";

const appReducer = combineReducers({
  app: AppReducer,
  auth: AuthReducer,
  orders: OrderReducer,
  associates: AssociateReducer,
  entregador: EntregadorReducer,
});

const rootReducer = (state, action) => {


  if (action.type === 'CLEAR_STORE') {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
